<template>
  <div class="submit-btn">
    <a
      href="#"
      @click="toggleButton"
    >
      <img
        class="submit-btn__img"
        alt="icon"
        src="../../assets/img/chatbot/menu.svg"
        :class="showClass"
      >
      <img
        class="submit-btn__img"
        alt="icon"
        src="../../assets/img/chatbot/close-menu.svg"
        :class="hideClass"
      >
    </a>
  </div>
</template>

<script>
export default {
    name: "SubmitButton",
    props: ["show",],
    data() {
        return {
            toggle: true,
        };
    },
    computed: {
        showClass() {
            return {
                "show": !this.show,
            };
        },
        hideClass() {
            return {
                "show": this.show,
            };
        },
    },
    methods: {
        toggleButton() {
            this.toggle = !this.show;
            this.$emit("clicked-show-menu", !this.show);
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
